import React from 'react'

import Footer from 'src/modules/organisms/footer/Footer'
import Layout from 'src/components/partials/Layout'
import SEO from 'src/components/partials/Seo'
import Step1 from 'src/modules/organisms/demo-flow/step1'

const DemoPage = () => {
  return (
    <Layout>
      <Step1
        attioCampaignId='b97064af-217f-4e80-a056-1037a89fae1f'
        nextStepPath='/li/demo/booking/'
        hsFormId='6147230e-39db-41e0-9cb7-344ee99ebc70'
      />
      <Footer showCta={false} hideFooterMain />
    </Layout>
  )
}

export default DemoPage

export const Head = () => (
  <SEO
    description={`Experience the fastest way to collect, onboard and migrate data with Flatfile and customize your personal demo showtime.`}
    title='Request a Flatfile Demo | Qualify for Apple Airpods 4'
    robots='hide'
  />
)
